import React, { createContext, useContext, useState } from 'react';

export interface ClientValidationContextProps {
  isClientValidationEnabled: boolean;
  setClientValidation: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ClientValidationContext = createContext<ClientValidationContextProps>({
  isClientValidationEnabled: true,
  setClientValidation: () => undefined,
});

export interface ClientValidationProviderProps {
  children?: React.ReactNode;
}

export const ClientValidationProvider = ({ children }: ClientValidationProviderProps): React.ReactElement => {
  const [isClientValidationEnabled, setIsClientValidationEnabled] = useState<boolean>(false);

  return (
    <ClientValidationContext.Provider
      value={{ isClientValidationEnabled, setClientValidation: setIsClientValidationEnabled }}
    >
      {children}
    </ClientValidationContext.Provider>
  );
};

export const useClientValidation = () => {
  return useContext(ClientValidationContext);
};
